import Image from 'next/image';
import { cn } from '@/utils';
import NoDataSvg from './no-data.svg';

type Props = {
  label: string;
  className?: string;
};

const NoNata = ({ label, className }: Props) => {
  return (
    <div className={cn('flex flex-col items-center justify-center', className)}>
      <Image src={NoDataSvg} alt="No data" width={100} height={100} />

      <span className="mt-4 text-xl">{label}</span>
    </div>
  );
};

export default NoNata;
